<div class="container" style="margin-top: 15%;">
    <H1 style="font-size: 80px;">Welcome</H1>
    <H1 style="font-size: 50px;">Have a great day</H1>
</div>

